import { render, staticRenderFns } from "./CauLink.vue?vue&type=template&id=a55357ce&lang=pug&"
import script from "./CauLink.vue?vue&type=script&lang=js&"
export * from "./CauLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CauLink.vue"
export default component.exports